'use client'

import { useSelf } from "@/apiUtilities/queries/useSelf"
import { useUserStore } from "@/stores/useUserStore"
import { PropsWithChildren } from "react"

export default function ({ children }: PropsWithChildren) {
  const { userId } = useUserStore()
  const { data: self } = useSelf({ enabled: !!userId })

  if (!userId || !self || !(!!self.product.windows_client)) return null

  return (
    <>
      {children}
    </>
  )
}